module.exports = __webpack_public_path__ + "img/Gigawhat_Official_Logo.fbc0d149.svg";